import * as React from 'react';
import { ScheduleDatePicker } from 'owa-mail-list-context-menu';
export default function getDatePicker(defaultTime, rowKeys, tableView, actionSource, dismissMenu) {
    return (React.createElement(ScheduleDatePicker, { defaultTime: defaultTime, rowKeys: rowKeys, tableView: tableView, actionSource: actionSource, dismissMenu: dismissMenu }));
}
//# sourceMappingURL=getDatePicker.js.map